export const popStateListener = (callback) => {
  window.onpopstate = function(event) {
    if(callback) callback(document.location, event.state)
  }
}

// Mozilla firefox issue - pushState can only be 640Kb.
// Use sessionStorage to persist the hotels and add a reference
// to the sessionStorage in the pushState
// Furthermore: sessionStorage has finite quantity as well. Keep history to
// at max 3 different destination changes
export const pushHotelsToSessionStorage = (state) => {
  sessionStorage.setItem(
    'hotelsHistory',
    JSON.stringify({
      hotels: state.hotels
    })
  )
}
